/* eslint-disable camelcase */
import en_auth from './en/auth.json';
import en_common from './en/common.json';
import en_tools from './en/tools.json';
import es_auth from './es/auth.json';
import es_common from './es/common.json';
import es_tools from './es/tools.json';
import pt_auth from './pt/auth.json';
import pt_common from './pt/common.json';
import pt_tools from './pt/tools.json';
import pt_Compartir_BR from './pt/Compartir-BR.json';
import pt_UnoInt_BR from './pt/UnoInt-BR.json';

export default {
  es: [es_auth, es_common, es_tools],
  en: [en_auth, en_common, en_tools],
  pt: [pt_auth, pt_common, pt_tools],
};

// Recursos específicos por tenant
export const tenantSpecificResources = {
  // Nombre del Tenant
  'UnoInt-BR': {
    pt: [pt_UnoInt_BR],
  },
  'Compartir-BR': {
    pt: [pt_Compartir_BR],
  },
};
